// removed by extract-text-webpack-plugin
module.exports = {"toggleBar":"ToggleBar__toggleBar__3ZZGn","disabled":"ToggleBar__disabled__1nSmq","fullWidth":"ToggleBar__fullWidth___YQIs","small":"ToggleBar__small__3X6dK","toggleOptionWrapper":"ToggleBar__toggleOptionWrapper__2Uw76","fullWidthOptionWrapper":"ToggleBar__fullWidthOptionWrapper__20HY6","whiteBackground":"ToggleBar__whiteBackground__sh0Oy","selected":"ToggleBar__selected__121F8"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ToggleBar/ToggleBar.scss
// module id = 1649
// module chunks = 0